module.exports = __webpack_public_path__ + "img/w.f7220a86.jpg";